import * as React from "react";
import AppContent from "../Surfaces/AppContent";
import {SharedColors, Stack} from "@fluentui/react";
import LinkTile from "../Components/LinkTile";

function Report() {
    return (
        <AppContent title={'Raporty'}>
            <Stack horizontal style={{marginTop: 20}} wrap horizontalAlign='space-around'>
                <LinkTile to={'/report/addon_sold'} color={SharedColors.cyanBlue20} title={'Sprzedane dodatki'} icon={'WebAppBuilderFragment'}/>
            </Stack>
        </AppContent>
    );
}

export default Report;